module.exports = __webpack_public_path__ + "static/media/video3_photo.84c8be8a.jpg";